window.addEventListener('DOMContentLoaded', function(event){

    const contactFooter = document.querySelector('.local__container')

    const contactBtn = document.querySelector('.stickyContact')

    var intersectionObserver = new IntersectionObserver(function(entries) {
        const [{ isIntersecting }] = entries;

        if (isIntersecting) {

            contactBtn.classList.add('hidden')
            
        } else {

            contactBtn.classList.remove('hidden')

        }

    });
    intersectionObserver.observe(contactFooter);

})